import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import SharedVideoEducationModal from "./SharedVideoEducationModal";
import SharedEducationModal from "./SharedEducationModal";
import {
  getAnnotatedRecords_Ajax,
  getCampaign_Ajax,
  getSecondOpinionCaseReport_Ajax
} from "../../helpers/requests";
import { useDispatch, useSelector } from "react-redux";
import {
  hideLoadingSpinner,
  showLoadingSpinner
} from "../../redux/actions/loadingSpinner";
import {
  formatDateTime,
  formatDateTimeWithZone,
  getDefaultPicPath,
  getTimeSince,
  handleApiErrors,
  isEmptyArray,
  isEqualToCurrentDate,
  isImageFile,
  isPDFfile,
  isValidDocFileForPatientUpload,
  onImageError,
  showAlertDialouge,
  toLocal,
  queryStringToJSON,
  getCampaignStatesOfType
} from "../../helpers/utils";
import moment from "moment";
import { DateTimeFormats, CampaignStateSettingTypes, SignatureType } from "../../constants";
import { setFileUrlToOpen } from "../../redux/actions/fileViewer";
import IconPDF from "./../../assets/images/icon-pdf.svg";
import GenericFileIcon from "../../assets/images/word_processor_file_icon.png";
import AttachedSignature from "../Print/AttachedSignature";

const RequestCompletedDetailPage = (props) => {
  const dispatch = useDispatch();
  const { secondOpinionId } = props;

  const campaignId = useSelector(
    (state) => state?.appSettings?.settingsData?.schedulerCampaignId
  );

  const patientOrigin = useSelector(
    (state) => state?.appSettings?.settingsData?.patientOrigin
  );

  const shouldDisplayCampaingChargeInfo = useSelector(
    (state) => state?.appSettings?.settingsData?.displayCampaignChargeForOrigins?.find(o => o == patientOrigin)
  );

  const [caseReport, setCaseReport] = useState(null);
  const [sharedEducation, setSharedEducation] = useState(null);
  const [sharedVideoEducation, setSharedVideoEducation] = useState(null);
  const [caseReportAnnotations, setCaseReportAnnotations] = useState(null);
  const [patientNotes, setPatientNotes] = useState([]);
  const [schedulerCampaign, setSchedulerCampaign] = useState(null);
  const [includeZState, setIncludeZState] = useState(false);

  useEffect(() => {
    if (secondOpinionId > 0) {
      getSecondOpinionCaseReport();
    }
    getCampaign(campaignId);
  }, []);

  useEffect(() => {
    if (caseReport && caseReport.caseReportId > 0) {
      getAnnotatedRecords();
    }
  }, [caseReport]);

  function getAnnotatedRecords() {
    if (caseReport && caseReport.caseReportId > 0) {
      dispatch(showLoadingSpinner());
      getAnnotatedRecords_Ajax(
        caseReport.caseReportId,
        function (response) {
          dispatch(hideLoadingSpinner());
          if (response && response.success && response.data) {
            setCaseReportAnnotations(response.data.caseReportAnnotations);
          } else if (response && !response.success && response.message) {
            showAlertDialouge("Error", response.message);
          }
        },
        function (err) {
          dispatch(hideLoadingSpinner());
          handleApiErrors(err);
        }
      );
    }
  }

  function getSecondOpinionCaseReport() {
    if (secondOpinionId && secondOpinionId > 0) {
      dispatch(showLoadingSpinner());
      getSecondOpinionCaseReport_Ajax(
        secondOpinionId,
        function (response) {
          dispatch(hideLoadingSpinner());
          if (response && response.success && response.data) {
            setCaseReport(response.data.caseReport);

            var arr = [];

            if (
              !isEmptyArray(response.data.caseReport.caseReportProgressNotes)
            ) {
              response.data.caseReport.caseReportProgressNotes.forEach(
                (note) => {
                  arr.push(note.progressNote);
                }
              );
            }

            setPatientNotes(arr);
          } else if (response && !response.success && response.message) {
            showAlertDialouge("Error", response.message);
          }
        },
        function (err) {
          dispatch(hideLoadingSpinner());
          handleApiErrors(err);
        }
      );
    }
  }

  function showSharedEducation(sharedEducation) {
    if (sharedEducation) {
      setSharedEducation(sharedEducation);
    }
  }

  function showSharedVideoEducation(sharedVideoEducation) {
    if (sharedVideoEducation) {
      setSharedVideoEducation(sharedVideoEducation);
    }
  }

  function getFormattedDateOfService(note) {
    if (note && note.dateOfService) {
      return (
        <p style={{ fontWeight: "bold" }}>
          Date of service:{" "}
          {formatDateTime(note.dateOfService, DateTimeFormats.MMM_DD_YYYY)}
        </p>
      );
    }
  }

  function openFile(url) {
    if (url) {
      dispatch(setFileUrlToOpen(url));
    }
  }

  function getNoteCreationTimeAndDate(note) {
    if (note && note.createdOn) {
      var creationTime = "";

      creationTime = formatDateTimeWithZone(
        toLocal(note.createdOn),
        DateTimeFormats.HH_MM_A
      );

      var creationDateOrTimeSince = "";

      if (isEqualToCurrentDate(note.createdOn)) {
        creationDateOrTimeSince = getTimeSince(note.createdOn) + " ago";
      } else {
        creationDateOrTimeSince = formatDateTime(
          toLocal(note.createdOn),
          DateTimeFormats.MMM_DD_YYYY
        );
      }

      if (creationTime && creationDateOrTimeSince) {
        return (
          <>
            <p className="fs-4 mb-0">{creationTime}</p>
            <span className="d-block">{creationDateOrTimeSince}</span>
          </>
        );
      }
    }
  }

  function getCampaign(campaignId) {
    let params = queryStringToJSON();
    let includeZState = false;
    if (params.includezstate) {
      if (params.includezstate == "true") {
        includeZState = true;
      }
    }
    setIncludeZState(includeZState);

    if (campaignId) {
      let params = {
        campaignId: campaignId,
        includeIntakeForm: false,
        includeZState: includeZState
      };

      dispatch(showLoadingSpinner());
      getCampaign_Ajax(
        params,
        function (response) {
          dispatch(hideLoadingSpinner());

          if (response && response.success && response.data) {
            if (response.data.campaignStates) {
              response.data.campaignStates = getCampaignStatesOfType(
                CampaignStateSettingTypes.Assigned,
                response.data.campaignStates
              );
            }
            setSchedulerCampaign(response.data);
          } else if (response && !response.success && response.message) {
            showAlertDialouge("Error", response.message);
          }
        },
        function (err) {
          dispatch(hideLoadingSpinner());
          handleApiErrors(err);
        }
      );
    }
  }

  function isScribeTypeSignature(note) {
    return note?.signatureType == SignatureType.Scribe
  }

  return (
    <>
      <div className="body-content">
        <section className="review-photo-section py-4 py-md-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="gth-main-header mb-3">
                  <div className="heading-wrapper back-to-wrapper position-relative">
                    {/* <!-- <a className="back-to text-body fs-1 lh-1 d-inline-block align-top position-absolute" href="case-reviews.html"><i className="bi bi-arrow-left lh-1 d-inline-block align-top"></i></a> --> */}
                    <h1 className="title">Reports</h1>
                  </div>
                </div>
                <div className="bg-white border-radius-xlg px-4 px-md-5 py-4">
                  <div className="form-group col-md-12">
                    <label className="form-label">Patient Information</label>
                    <div className="form-section">
                      {caseReport && caseReport.secondOpinion.patient ? (
                        <>
                          <div className="gth-corpote-report">
                            <p>
                              <b>Name</b>
                            </p>
                            {caseReport.secondOpinion.patient.fullName ? (
                              <p>{caseReport.secondOpinion.patient.fullName}</p>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="gth-corpote-report">
                            <p>
                              <b>Date of Birth</b>
                            </p>
                            {caseReport.secondOpinion.patient.dateOfBirth ? (
                              <p>
                                {moment(
                                  caseReport.secondOpinion.patient.dateOfBirth
                                ).format("MM/DD/YYYY")}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      {caseReport && caseReport.secondOpinion ? (
                        <div className="gth-corpote-report">
                          <p>
                            <b>Request Submitted on</b>
                          </p>
                          <p>
                            {moment(caseReport.secondOpinion.createdOn).format(
                              "MM/DD/YYYY"
                            )}
                          </p>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div className="form-group mt-4 mb-3 col-md-12">
                    <label className="form-label">Second Opinion Report</label>
                    <div className="d-flex flex-wrap align-items-center mt-1">
                      {caseReport && caseReport.provider ? (
                        <>
                          {caseReport.provider.photoId ? (
                            <div>
                              <img
                                className="img-70 rounded-circle"
                                src={caseReport.provider.photoId}
                                onError={onImageError}
                                alt=""
                              />
                            </div>
                          ) : (
                            <></>
                          )}
                          <div className="flex-1 ps-3">
                            {caseReport.provider.fullName ? (
                              <div>{caseReport.provider.fullName}</div>
                            ) : (
                              <></>
                            )}
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  {!isEmptyArray(caseReportAnnotations) ? (
                    <div className="form-group mt-4 mb-3 col-md-12">
                      <label className="form-label">Annotated Photos</label>
                      <div className="thumb-img-wrapper d-flex flex-nowrap overflow-auto tz-gallery">
                        {caseReportAnnotations.map((annotation, index) => {
                          if (isImageFile(annotation.photoId)) {
                            return (
                              <>
                                <a
                                  href="#"
                                  className="lightbox"
                                  data-bs-toggle="modal"
                                  data-toggle="modal"
                                  data-bs-target="#fileViewerImage"
                                  onClick={() => openFile(annotation.photoId)}
                                >
                                  <img
                                    className=""
                                    src={annotation.photoId}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null;
                                      currentTarget.src =
                                        getDefaultPicPath(currentTarget);
                                    }}
                                    alt="File img"
                                  />
                                </a>
                              </>
                            );
                          } else if (
                            isValidDocFileForPatientUpload(annotation.photoId)
                          ) {
                            return (
                              <a
                                href="#"
                                className="lightbox"
                                data-bs-toggle="modal"
                                data-toggle="modal"
                                data-bs-target="#fileViewerDoc"
                                onClick={() => openFile(annotation.photoId)}
                              >
                                <img
                                  className=""
                                  src={
                                    isPDFfile(annotation.photoId)
                                      ? IconPDF
                                      : GenericFileIcon
                                  }
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src =
                                      getDefaultPicPath(currentTarget);
                                  }}
                                  alt="File img"
                                />
                              </a>
                            );
                          } else {
                            return (
                              <a
                                href={annotation.photoId}
                                target="_blank"
                                className="lightbox"
                              >
                                <img
                                  src={annotation.photoId}
                                  onError={onImageError}
                                  alt="File img"
                                />
                              </a>
                            );
                          }
                        })}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {!isEmptyArray(patientNotes) ? (
                    <div className="form-group mt-4 mb-3 col-md-12">
                      <label className="form-label">
                        General Progress Notes
                      </label>
                      <table className="table">
                        <thead>
                          <tr>
                            <th style={{ width: "130px" }}>Date</th>
                            <th>Note</th>
                          </tr>
                        </thead>
                        <tbody>
                          {patientNotes.map((note, index) => {
                            return (
                              <tr>
                                <td data-label="Date">
                                  {getNoteCreationTimeAndDate(note)}
                                </td>
                                <td className="text-break" data-label="Note">
                                  <div>{getFormattedDateOfService(note)}</div>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: note?.description
                                    }}
                                  ></div>
                                  <AttachedSignature
                                    isSignatureAttached={note?.isSignatureAttached}
                                    attachedSignature={note?.attachedSignature}
                                    isScribeTypeSignature = {isScribeTypeSignature(note)}
                                  />
                                </td>
                                
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <></>
                  )}
                  {caseReport && caseReport.recommendation ? (
                    <div className="form-group mt-4 mb-3 col-md-12">
                      <label className="form-label">
                        Second Opinion Treatment Recommendation
                      </label>
                      <p className="text-muted">{caseReport.recommendation}</p>
                    </div>
                  ) : (
                    <></>
                  )}
                  {caseReport &&
                  !isEmptyArray(caseReport.caseReportVideoEducations) ? (
                    <div className="form-group mt-4 mb-3 col-md-12">
                      <label className="form-label">
                        Shared Video Education
                      </label>
                      <table
                        cellPadding="0"
                        cellSpacing="0"
                        border="0"
                        width="100%"
                      >
                        {caseReport.caseReportVideoEducations.map(
                          (videoEducation, index) => {
                            return (
                              <tr>
                                <td className="py-1 w-50 align-top">
                                  {
                                    videoEducation.patientVideoEducation
                                      .videoEducation.title
                                  }
                                </td>
                                <td className="py-1 w-50 align-top text-end text-md-start">
                                  <a
                                    href="#"
                                    onClick={() => {
                                      showSharedVideoEducation(
                                        videoEducation.patientVideoEducation
                                      );
                                    }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#videoEducationModal"
                                    className="text-decoration-none"
                                  >
                                    View{" "}
                                    <i className="bi bi-box-arrow-up-right"></i>
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </table>
                    </div>
                  ) : (
                    <></>
                  )}
                  {caseReport &&
                  !isEmptyArray(caseReport.caseReportEducations) ? (
                    <div className="form-group mt-4 mb-3 col-md-12">
                      <label className="form-label">Shared Education</label>
                      <table
                        cellPadding="0"
                        cellSpacing="0"
                        border="0"
                        width="100%"
                      >
                        {caseReport.caseReportEducations.map(
                          (education, index) => {
                            return (
                              <tr
                                key={education.patientEducation.education.educationId.toString()}
                              >
                                <td className="py-1 w-50 align-top">
                                  {education.patientEducation.education.title}
                                </td>
                                <td className="py-1 w-50 align-top text-end text-md-start">
                                  <a
                                    href="#"
                                    onClick={() => {
                                      showSharedEducation(
                                        education.patientEducation.education
                                      );
                                    }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#educationModal"
                                    className="text-decoration-none"
                                  >
                                    View{" "}
                                    <i className="bi bi-box-arrow-up-right"></i>
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </table>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="text-primary text-center mt-5">
                    If you would like to further discuss your treatment
                    recommendation with this provider, please schedule an
                    appointment
                  </div>
                  <div className="form-group text-center mt-4 col-md-12">
                    {caseReport ? (
                      <Link
                        className="btn btn-secondary btn-rounded btn-lg px-3 px-md-5 w-100 w-md-auto"
                        to={
                          includeZState
                            ? "/second-opinion-appointment?includeZState=true"
                            : "/second-opinion-appointment"
                        }
                        state={{
                          patientId: caseReport.patientId,
                          providerId: caseReport.providerId,
                          patientName: caseReport.secondOpinion.patient.fullName
                        }}
                      >
                        Schedule an appointment
                        {schedulerCampaign &&
                        shouldDisplayCampaingChargeInfo &&
                        schedulerCampaign.campaignCharge ? (
                          <> ${schedulerCampaign.campaignCharge}</>
                        ) : (
                          <></>
                        )}
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <SharedVideoEducationModal sharedVideoEducation={sharedVideoEducation} />
      <SharedEducationModal sharedEducation={sharedEducation} />
    </>
  );
};

export default RequestCompletedDetailPage;
